export const paths = {
	dashboard: { root: "/dashboard" },
	scheduling: {
		scheduler: "/scheduler",
		spreadsheet: "/spreadsheet",
		spreadsheetView: "/spreadsheet-view",
		spreadsheetReport: "/spreadsheet-report",
		autoAssignment: {
			regular: "/auto-assignment/",
			regularSub: "/auto-assignment/:subTab",
			roadScholar: "/auto-assignment/rs",
			roadScholarSub: "/auto-assignment/rs/:subTab",
		},
		proposals: "/proposals",
		confirmations: "/confirmations",
		tourLeaderActions: {
			list: "/tour-leader-actions",
			edit: "/tour-leader-actions/:id",
		},
	},
	management: {
		users: {
			list: "/management/users",
			edit: "/management/users/:id",
			create: "/management/users/create",
			resetPassword: "/management/users/reset-password",
		},
		tours: {
			list: "/management/tours",
			edit: "/management/tours/:id",
		},
		departures: {
			list: "/management/departures",
			edit: "/management/departures/:id",
		},
		systemSettings: "/management/system-settings",
		seasonManagement: "/management/system-settings/season",
		tourLeaders: {
			list: "/management/tour-leaders",
			edit: "/management/tour-leaders/:id",
			create: "/management/tour-leaders/create",
			unavailability: "/management/tourleaders/unavailability",
			unavailabilityExample: "/management/unavailability-example",
			unavailabilityExample2: "/management/unavailability-example-2",
		},
	},
	logs: {
		auditLogs: "/logs/audit-logs",
		dataImportLogs: "/logs/data-import-logs",
	},

	dataImports: {
		root: "/data-imports",
	},

	reports: {
		root: "/reports",
	},

	account: {
		profile: "/account/profile",
		changePassword: "/account/change-password",
	},

	documentation: {
		root: "/docs",
	},

	auth: {
		root: "/",
		forgotPassword: "/forgot-password",
	},

	test: {
		root: "/test",
	},
};
